
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[city]/[buildingId]/[addressSlug]",
      function () {
        return require("private-next-pages/building/[city]/[buildingId]/[addressSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[city]/[buildingId]/[addressSlug]"])
      });
    }
  